import { useLocation, Location } from 'react-router-dom';
import { handleRouterContextError } from '@/lib/services/routerContextService';

/**
 * Safe wrapper around useLocation with fallback to window.location
 * when used outside Router context.
 */
export function useSafeLocation(): Location {
  try {
    return useLocation();
  } catch (error) {
    // Handle Router context error and provide fallback
    handleRouterContextError('useLocation', error, 'window_fallback');
    
    // Return fallback location based on window.location
    return {
      pathname: window.location.pathname,
      search: window.location.search,
      hash: window.location.hash,
      state: null,
      key: 'default',
    };
  }
}
